const CONSENT_KEY = "hospicecare_life_cookie_consent";

export const onInitialClientRender = () => {
  const consent = localStorage.getItem(CONSENT_KEY);

  if (consent === "granted" && typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      analytics_storage: "granted",
      ad_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
    });
  }
};
